// extracted by mini-css-extract-plugin
export default {"modalWrap":"FactorModal_modalWrap__golQU","textDescription":"FactorModal_textDescription__PF1QI","imgWrap":"FactorModal_imgWrap__1+cb-","frameCycle":"FactorModal_frameCycle__EIizw"};